import type { FaireProductEntity } from "../../entity_types/product";

export const p_v7hnggcq2d: FaireProductEntity = {
  token: "p_v7hnggcq2d",
  type: "product",
  name: "12PCS - Assorted Happy Birthday Card Set",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/c37a9c0d076698eb860203b5fa5db8372e1dee5b0ea95c7425cac48796bde496.jpeg",
  priceDollars: 0.69,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/daaa2e233715709cb40ea97e80393752586314d20328094efcf2b90b9c964e60.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
